import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_ADMIN_INCENTIVE_BUDGETS = `${URL_APP_ADMIN}/incentive-budgets`
const URL_ADMIN_INCENTIVE_BUDGETS_LIST = `${URL_ADMIN_INCENTIVE_BUDGETS}/list`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-incentive-budgets'>
  | DashRouteType<'app-admin-incentive-budgets-list'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-incentive-budgets': URL_ADMIN_INCENTIVE_BUDGETS,
  'app-admin-incentive-budgets-list': URL_ADMIN_INCENTIVE_BUDGETS_LIST,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
